
import has from './has'
import loadMore from './load-more'

const directives = [has,loadMore]

const install = {
  install: Vue => {
    directives.forEach(o => {
      Vue.directive(`Hi${o.name}`, o.directive)
    })
  }
}
export default install
